import { readEnv } from "openai/core";

import { OPClient } from "./codegen";
import { OpenPipeConfig } from "./shared";

export default class OpenPipe {
  baseClient: OPClient;

  constructor(config: OpenPipeConfig = {}) {
    const openPipeApiKey = config?.apiKey ?? readEnv("OPENPIPE_API_KEY");
    const openpipeBaseUrl = config?.baseUrl ?? readEnv("OPENPIPE_BASE_URL");

    this.baseClient = new OPClient({
      BASE: openpipeBaseUrl,
      TOKEN: openPipeApiKey,
    });
  }

  updateLogTags(...params: Parameters<OPClient["default"]["updateLogTags"]>) {
    return this.baseClient.default.updateLogTags(...params);
  }

  updateLogMetadata(...params: Parameters<OPClient["default"]["updateLogMetadata"]>) {
    return this.baseClient.default.updateLogMetadata(...params);
  }

  report(...params: Parameters<OPClient["default"]["report"]>) {
    return this.baseClient.default.report(...params);
  }

  getCriterionJudgement(...params: Parameters<OPClient["default"]["getCriterionJudgement"]>) {
    return this.baseClient.default.getCriterionJudgement(...params);
  }

  reportAnthropic(...params: Parameters<OPClient["default"]["reportAnthropic"]>) {
    return this.baseClient.default.reportAnthropic(...params);
  }

  createDataset(...params: Parameters<OPClient["default"]["createDataset"]>) {
    return this.baseClient.default.createDataset(...params);
  }
  unstableDatasetCreate(...params: Parameters<OPClient["default"]["unstableDatasetCreate"]>) {
    return this.baseClient.default.unstableDatasetCreate(...params);
  }

  listDatasets(...params: Parameters<OPClient["default"]["listDatasets"]>) {
    return this.baseClient.default.listDatasets(...params);
  }

  deleteDataset(...params: Parameters<OPClient["default"]["deleteDataset"]>) {
    return this.baseClient.default.deleteDataset(...params);
  }
  unstableDatasetDelete(...params: Parameters<OPClient["default"]["unstableDatasetDelete"]>) {
    return this.baseClient.default.unstableDatasetDelete(...params);
  }

  createDatasetEntries(...params: Parameters<OPClient["default"]["createDatasetEntries"]>) {
    return this.baseClient.default.createDatasetEntries(...params);
  }
  unstableDatasetEntryCreate(
    ...params: Parameters<OPClient["default"]["unstableDatasetEntryCreate"]>
  ) {
    return this.baseClient.default.unstableDatasetEntryCreate(...params);
  }

  createModel(...params: Parameters<OPClient["default"]["createModel"]>) {
    return this.baseClient.default.createModel(...params);
  }
  unstableFinetuneCreate(...params: Parameters<OPClient["default"]["unstableFinetuneCreate"]>) {
    return this.baseClient.default.unstableFinetuneCreate(...params);
  }

  getModel(...params: Parameters<OPClient["default"]["getModel"]>) {
    return this.baseClient.default.getModel(...params);
  }
  unstableFinetuneGet(...params: Parameters<OPClient["default"]["unstableFinetuneGet"]>) {
    return this.baseClient.default.unstableFinetuneGet(...params);
  }

  listModels(...params: Parameters<OPClient["default"]["listModels"]>) {
    return this.baseClient.default.listModels(...params);
  }

  deleteModel(...params: Parameters<OPClient["default"]["deleteModel"]>) {
    return this.baseClient.default.deleteModel(...params);
  }
  unstableFinetuneDelete(...params: Parameters<OPClient["default"]["unstableFinetuneDelete"]>) {
    return this.baseClient.default.unstableFinetuneDelete(...params);
  }
}
